module.exports = {
      id: "apple-usage",
      viewBox: "0 0 56 56",
      url: __webpack_public_path__ + "svg-sprite-fef6f85605acbf641cce7cd75d6011b0.svg#apple",
      toString: function () {
        return this.url;
      }
    }